export default class ChartConfigurations {
    public fillColor: string[];
    public strokeColor: string[];
    public highlightFill: string[];
    public highlightStroke: string[];

    public backgroundColor: string[];
    public borderColor: string[];
    public pointBackgroundColor: string[];
    public pointBorderColor: string[];
    public pointHoverBackgroundColor: string[];
    public pointHoverBorderColor: string[];

    constructor(_input: any[]) {
        this.fillColor = [];
        this.strokeColor = [];
        this.highlightFill = [];
        this.highlightStroke = [];
        this.backgroundColor = [];
        this.borderColor = [];
        this.pointBackgroundColor = [];
        this.pointBorderColor = [];
        this.pointHoverBackgroundColor = [];
        this.pointHoverBorderColor = [];

        for (let index in _input) {
            if (
                index !== 'prototype' &&
                index !== '__proto__'
            )  {

                let input = _input[index];

                this.fillColor.push(input.fillColor);
                this.strokeColor.push(input.strokeColor);
                this.highlightFill.push(input.highlightFill);
                this.highlightStroke.push(input.highlightStroke);
                this.backgroundColor.push(input.backgroundColor);
                this.borderColor.push(input.borderColor);
                this.pointBackgroundColor.push(input.pointBackgroundColor);
                this.pointBorderColor.push(input.pointBorderColor);
                this.pointHoverBackgroundColor.push(input.pointHoverBackgroundColor);
                this.pointHoverBorderColor.push(input.pointHoverBorderColor);    
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/stores/application/classes/ChartConfigurations.ts